import { Injectable } from '@angular/core';

@Injectable()
export class CookieService {
    constructor() {
        // constructor
    }

    public clearAll() {
        let cookies = ["userInput", "Order", "Center", "homeZome", "Package", "PackageAll", "selectedGeometry", "Product", "Report", "DataSources", "Address1", "address", "address1", 'PostalZip', 'City', 'City1', "country", "country1", "ProvState", "ProvState1", "DataSourcesCode", "PName", "PONumber", "reqInfo", "optionInfo", "savedOrder", "OrderID", "UplaodGeometryFilelocation", "UplaodFileName", "parIdArray", "StreetNo", "Street"];
        for (let name of cookies) {
            if (sessionStorage.getItem(name)) {
                sessionStorage.removeItem(name);
            }
        }
    }

    public clearSession() {
        sessionStorage.clear();
    }

    public clearPre() {
        let cookies = ["Order", "Package", "PackageAll", "Product", "Report", "DataSources", "DataSourcesCode", "PName", "PONumber", "reqInfo", "optionInfo", 'savedOrder', "OrderID"];
        for (let name of cookies) {
            if (sessionStorage.getItem(name)) {
                sessionStorage.removeItem(name);
            }
        }
    }
    public getCookie(name: string) {
        if (sessionStorage.getItem(name)) {
            let data = sessionStorage.getItem(name);
            return data
        } else {
            return ''
        }
    }

    public deleteCookie(name) {
        if (sessionStorage.getItem(name)) {
            sessionStorage.removeItem(name);
        }
    }

    public setCookie(name: string, value: any) {
        sessionStorage.setItem(name, value);
    }

    public setCookieSession(name: string, value: any) {
        sessionStorage.setItem(name, value);
    }
}